<template>
  <div class="layout" :class="style">
    <meal-image
      v-for="(meal, i) in meals"
      :class="'sec sec-' + i"
      class="meal-jumbo"
      :key="i"
      :src="meal.imageUrl"
      :style="fontSizeStyle"
    >
      <div class="meal-number">{{ meal.order || i + 1 }}</div>
      <div class="badges">
        <div class="icon badge" v-for="badge in badges(meal)" :key="badge.name">
          <img :src="badge.icon" />
        </div>
      </div>
      <div class="meal-name-box">
        <!-- prettier-ignore -->
        <div class="meal-name">{{ meal.name }} <span class="allergens">{{ allergens(meal) }}</span></div>
      </div>
      <div class="meal-price-box">
        <div class="meal-price">{{ meal.price | money }} {{ currency }}</div>
      </div>
    </meal-image>
  </div>
</template>

<script>
import MealImage from "@/components/meal-image"
import { state } from "@/store"
import { allergenCodes, badgeCodes } from "@/service/meal-constants"
import { slicer } from "@/utils"

export default {
  maxMeals: 4,
  slicer: slicer.fillMinimumMealsPerScreen,
  name: "layout-image-default",
  props: ["meals"],
  components: { MealImage },
  computed: {
    style() {
      switch (this.meals.length) {
        case 1:
          return "single"
        case 2:
          return "double"
        case 3:
          return "tripple"
        case 4:
          return "quadruple"
        default:
          return "single"
      }
    },
    fontSizeStyle() {
      switch (this.meals.length) {
        case 1:
          return "font-size: 1.13636em;"
        default:
          return "font-size: 0.85227em;"
      }
    },
    currency() {
      return state.project.data.currency
    }
  },
  methods: {
    allergens(meal) {
      return allergenCodes(meal.allergens, "(", ")")
    },
    badges(meal) {
      return badgeCodes(meal.badges)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

$border-style: $screen-border-size $screen-border-color solid;
// ideal use case for cssgrid, but not supported on fireos5
.layout {
  background: #888;
  .sec {
    position: absolute;
  }
  &.single {
    .sec {
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  &.double {
    .sec-0 {
      top: 0;
      left: 0;
      width: 50%;
      height: 100%;
      border-right: $border-style;
    }
    .sec-1 {
      top: 0;
      left: 50%;
      width: 50%;
      height: 100%;
      border-left: $border-style;
    }
  }
  &.tripple {
    .sec-0 {
      top: 0;
      left: 0;
      width: 50%;
      height: 100%;
      border-right: $border-style;
    }
    .sec-1 {
      top: 0;
      left: 50%;
      width: 50%;
      height: 50%;
      border-left: $border-style;
      border-bottom: $border-style;
    }
    .sec-2 {
      top: 50%;
      left: 50%;
      width: 50%;
      height: 50%;
      border-left: $border-style;
      border-top: $border-style;
    }
  }
  &.quadruple {
    .sec-0 {
      top: 0;
      left: 0;
      width: 50%;
      height: 50%;
      border-right: $border-style;
      border-bottom: $border-style;
    }
    .sec-1 {
      top: 0;
      left: 50%;
      width: 50%;
      height: 50%;
      border-left: $border-style;
      border-bottom: $border-style;
    }
    .sec-2 {
      top: 50%;
      left: 0;
      width: 50%;
      height: 50%;
      border-right: $border-style;
      border-top: $border-style;
    }
    .sec-3 {
      top: 50%;
      left: 50%;
      width: 50%;
      height: 50%;
      border-left: $border-style;
      border-top: $border-style;
    }
  }
}
.meal-jumbo {
  color: $screen-text-color;
  height: 100%;
  width: 100%;
  font-family: "Arial", serif;
  .meal-name-box {
    white-space: pre-wrap;
    position: absolute;
    bottom: 0;
    left: 0;
    box-shadow: 0.1em 0.1em 0.1em 0em $screen-border-color;
    width: calc(100% - 0.8em);
    margin: 0.4em 0.4em 0.4em 0.4em;
    padding: 0.6em 0.6em 0.3em 0.6em;
    background-color: rgba($screen-label-color, 0.88);
    border-radius: 3px;
    min-height: 3.25em;
    text-shadow: -0.01em 0 $screen-border-color, 0 0.01em $screen-border-color,
      0.01em 0 $screen-border-color, 0 -0.01em $screen-border-color;
    .meal-name {
      line-height: 1em;
      font-size: 2.9em;
      font-weight: 400;
    }
    .allergens {
      font-size: 0.5em;
      vertical-align: super;
    }
  }
  .meal-price-box {
    position: absolute;
    right: 0.4em;
    top: 0.4em;
    background-color: rgba($screen-label-color, 0.88);
    box-shadow: 0.1em 0.1em 0.1em 0em $screen-border-color;
    height: 8em;
    width: 16em;
    border-radius: 50%;
    padding-right: 0.5em;
    padding-left: 0.5em;
    text-shadow: -0.03em 0 $screen-border-color, 0 0.03em $screen-border-color,
      0.03em 0 $screen-border-color, 0 -0.03em $screen-border-color;
    display: flex;
    align-items: center;
    justify-content: center;
    .meal-price {
      font-size: 4.25em;
    }
  }
  .meal-number {
    display: none;
  }
  .badges {
    position: absolute;
    top: 10em;
    right: 0.4em;
    width: 5em;
    .badge {
      padding-right: 0.25em;
      padding-bottom: 0.25em;
      height: 5em;
      width: 5em;
      filter: drop-shadow(0.1em 0.1em 0.1em $screen-border-color);
      img {
        opacity: 0.8;
        width: 100%;
        filter: grayscale(1) contrast(100);
      }
    }
  }
}
</style>
